import { useCancelClaim } from "../hooks/use-cancel-claim";

import type { PaymentKind } from "../types";

type CancelablePaymentKind = Extract<PaymentKind, "mileage" | "receipt">;

export interface CancelableState {
  isCancelPending: boolean;
  onCancelConfirm: () => void;
}

export const useCancelableState = (
  paymentKind: CancelablePaymentKind,
  id: string
): CancelableState => {
  const { onCancel, isPending } = useCancelClaim({ paymentKind, id });

  return {
    isCancelPending: isPending,
    onCancelConfirm: onCancel,
  };
};
